<template>
    <div class="further-details card h-auto card-filled">
        <div class="card__text h-100 justify-content-center px-2 py-2">
            <ul
                v-for="(category, index) in details"
                :key="index"
                class="further-details__list p-0"
            >
                <h3>
                    {{ category.name }}
                </h3>
                <ul class="p-0">
                    <li
                        v-for="(item, id) in category.items"
                        :key="id"
                        class="d-flex flex-row justify-content-between mb-1"
                    >
                        {{ item.text }}: {{ item.date }}
                        <a
                            v-if="item.link"
                            :href="item.link.url"
                            :alt="item.link.name"
                            target="_blank"
                            >view</a
                        >
                    </li>
                </ul>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        details: {
            type: Array,
            default() {
                return [];
            }
        }
    },

    data() {
        return {};
    }
};
</script>

<style lang="scss">
.further-details {
    border-bottom: 5px solid $brand-blue;
}

.further-details h3 {
    font-size: 1rem;
    font-family: $font-family-sans-serif;
    font-weight: $font-weight-bold;
}

.further-details__list a {
    color: $brand-green;
    border-bottom: 1px solid;
}
</style>
